// Flavour toggle for snippets/nc-offer-card.liquid. Delegated from the document,
// so cards the cart drawer re-renders by innerHTML keep working.
if (!window.ncOfferCardReady) {
  window.ncOfferCardReady = true;
  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio.matches || !radio.matches('[data-nc-offer-flavour]') || !radio.checked) return;
    var card = radio.closest('[data-nc-offer]');
    if (!card) return;
    var variantInput = card.querySelector('[data-nc-offer-variant]');
    var propertyInput = card.querySelector('[data-nc-offer-property]');
    if (variantInput) variantInput.value = radio.value;
    if (propertyInput) propertyInput.value = radio.dataset.flavour;
  });
}
